export const handleTooltip = tooltip =>{
  let formattedToolTip = tooltip

  // TODO: when tooltips for Marianatek and Zingfit will be implemented get rid of this checking
  if (tooltip=== "Previous undefined") formattedToolTip = ""

  if(formattedToolTip && formattedToolTip.includes("Previous")){
    formattedToolTip = tooltip.replace(", % change from last month", "")
    return formattedToolTip
  }

  return formattedToolTip
}
